import styled from 'styled-components';

export const CountyMapWrapper = styled.div`
  position: relative;
`;

export const CountyMapLayerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .rsm-geography {
    cursor: pointer;
  }
`;
